import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { ThemeProvider } from '../context/themeContext';

const Layout = ({ children }) => {
  const history = useHistory();
  const onPageClicked = (url, e) => {
    e.preventDefault();
    if (window.location.pathname !== url) {
      history.push(url);
    }
  };
  return (
    <ThemeProvider>
      <div className="flex flex-col h-screen justify-between">
        <Header onPageClicked={onPageClicked} />
        <main className="mb-auto mt-20 main-container">{children}</main>
        <Footer onPageClicked={onPageClicked} />
      </div>
    </ThemeProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
export default Layout;
